<template>
  <!-- Side work control for administrators: findings of the daily check, the project registry, parameters. -->
  <section class="ai-side">
    <div class="ai-side__intro">
      <h3>Сторонние проекты</h3>
      <p>
        Ежедневная проверка ищет признаки работы над сторонними проектами: чертежи, документы и другие
        файлы вне папок проектов из реестра, неизвестные шифры, отправки файлов посторонним, работу
        в нерабочее время. Находка — повод разобраться, а не доказательство.
      </p>
    </div>

    <div
      class="ai-segmented ai-side__tabs"
      role="tablist"
    >
      <button
        v-for="item in tabs"
        :key="item.key"
        type="button"
        role="tab"
        :aria-selected="tab === item.key ? 'true' : 'false'"
        :class="{ 'is-active': tab === item.key }"
        @click="tab = item.key"
      >
        {{ item.label }}
        <span
          v-if="item.key === 'findings' && newFindings"
          class="ai-side__count"
        >{{ newFindings }}</span>
      </button>
    </div>

    <!-- Tabs keep their state (a form in progress, filters) while another one is open. -->
    <keep-alive>
      <sidework-findings v-if="tab === 'findings'" />
      <sidework-registry v-else-if="tab === 'registry'" />
      <sidework-settings
        v-else
        @close="$emit('close')"
      />
    </keep-alive>
  </section>
</template>

<script>
  import SideworkFindings from './SideworkFindings.vue';
  import SideworkRegistry from './SideworkRegistry.vue';
  import SideworkSettings from './SideworkSettings.vue';

  const TABS = [
    { key: 'findings', label: 'Находки' },
    { key: 'registry', label: 'Реестр' },
    { key: 'settings', label: 'Параметры' },
  ];

  export default {
    name: 'SideworkPanel',
    components: { SideworkFindings, SideworkRegistry, SideworkSettings },
    data: () => ({ tab: 'findings', tabs: TABS }),
    computed: {
      newFindings() {
        return this.$store.getters['assistant/sidework'].newFindings || 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ai-side {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 14px;
    min-height: 0;
    padding: 16px 18px;
    overflow-y: auto;
  }

  .ai-side__intro {
    h3 {
      margin: 0 0 4px;
      color: var(--ui-text);
      font-size: 16px;
      font-weight: 500;
    }

    p {
      margin: 0;
      color: var(--ui-text-muted);
      font-size: 13px;
      line-height: 1.5;
    }
  }

  .ai-side__tabs {
    align-self: flex-start;
    max-width: 100%;
    overflow-x: auto;
  }

  .ai-side__count {
    display: inline-block;
    min-width: 16px;
    margin-left: 4px;
    padding: 0 4px;
    box-sizing: border-box;
    border-radius: 999px;
    background: var(--ui-warning);
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    vertical-align: 1px;
  }
</style>
